"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var TableMenuIsDeprecated_1 = require("../../../../../../shared/components/table_menus/TableMenuIsDeprecated");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var TableActionConfirm_1 = require("../../../../../../shared/components/table_actions/TableActionConfirm");
var UsrPermissionsList = /** @class */ (function (_super) {
    __extends(UsrPermissionsList, _super);
    function UsrPermissionsList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Название',
                dataIndex: _this.props.data.dk_title,
                key: _this.props.data.dk_title,
                width: 200,
                render: function (text, record, index) {
                    return (React.createElement("div", null,
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "user-shield" }),
                        " ",
                        record.title,
                        " "));
                }
            }, {
                title: 'Изменен',
                dataIndex: _this.props.data.dk_date_changed2,
                key: _this.props.data.dk_date_changed2,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_changed2.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Доступно для',
                dataIndex: _this.props.data.dk_allowed_admins_count,
                key: _this.props.data.dk_allowed_admins_count,
                align: "center",
                width: 120,
            }, {
                title: 'Кол-во документов',
                dataIndex: _this.props.data.dk_allowed_documents_count,
                key: _this.props.data.dk_allowed_documents_count,
                width: 120,
                align: "center",
            }, {
                title: 'Устаревший',
                dataIndex: _this.props.data.dk_is_deprecated,
                key: _this.props.data.dk_is_deprecated,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDeprecated_1.default, { deprecatedTexts: { menu: "Пометить как устаревший", text: "Да" }, notDeprecatedTexts: { menu: "Пометить как актуальный", text: "Нет" }, record: { key: record.key, title: record.title, deprecated: record.is_deprecated }, onDeprecateClick: _this.doDeprecateAction.bind(_this) }));
                },
                width: 120,
            }, {
                title: 'Описание',
                dataIndex: _this.props.data.dk_comment,
                key: _this.props.data.dk_comment,
                width: 250,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigPermissionClick(record); } }),
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditPermissionClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePermissionClick(record); } }),
                    React.createElement(TableActionConfirm_1.default, { hint: "\u0418\u043C\u043F\u043E\u0440\u0442 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432", confirmText: "\u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 ?", onClick: function () { _this.onImportDocumentsClick(record); } }))); },
                width: 160
            }
        ];
        return _this;
    }
    UsrPermissionsList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    UsrPermissionsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0
        }, function () {
            _this.props.data.LoadData();
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    UsrPermissionsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    UsrPermissionsList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.data.LoadData();
            });
        }
    };
    UsrPermissionsList.prototype.doDeprecateAction = function (key, title, deprecate) {
        this.props.data.SetPermissionIsDeprecated(key, deprecate, function () {
            if (deprecate) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041D\u0430\u0431\u043E\u0440 \u043F\u0440\u0430\u0432 ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u043E\u0442\u043C\u0435\u0447\u0435\u043D \u043A\u0430\u043A \u0443\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0438\u0439"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041D\u0430\u0431\u043E\u0440 \u043F\u0440\u0430\u0432 ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u043E\u0442\u043C\u0435\u0447\u0435\u043D \u043A\u0430\u043A \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0439"));
            }
        });
    };
    UsrPermissionsList.prototype.onImportDocumentsClick = function (record) {
        var _this = this;
        this.props.data.doFillPermission(record.key, function () {
            _this.props.data.LoadData(function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0421\u043F\u0438\u0441\u043E\u043A \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0434\u043B\u044F ",
                    React.createElement("b", null,
                        "[",
                        record.title,
                        "]"),
                    " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u043D!"));
            });
        });
    };
    UsrPermissionsList.prototype.onAccessConfigClick = function (record) {
        if (this.props.onAccessConfigClick) {
            this.props.onAccessConfigClick(record);
        }
    };
    UsrPermissionsList.prototype.onEditPermissionClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    UsrPermissionsList.prototype.onConfigPermissionClick = function (record) {
        if (this.props.onGoToDocksListClick) {
            this.props.onGoToDocksListClick(record);
        }
    };
    UsrPermissionsList.prototype.onDeletePermissionClick = function (record) {
        this.props.data.DeletePermission(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041D\u0430\u0431\u043E\u0440 \u043F\u0440\u0430\u0432 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    UsrPermissionsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.props.data.LoadData(function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    UsrPermissionsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData();
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    UsrPermissionsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] ")));
                }, scroll: { x: true } })));
    };
    return UsrPermissionsList;
}(React.Component));
exports.default = UsrPermissionsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/usr_permissions_list/ui/component/UsrPermissionsList.tsx
// module id = 1887
// module chunks = 0